import types from '../../types';

const bnixFee = (
  state = { loading: true, data: null, levels: null },
  { type, payload },
) => {
  switch (type) {
    case types.GET_BNIX_FEE_START:
      return { ...state, loading: true };

    case types.GET_BNIX_FEE_SUCCESS:
      return { data: payload, levels: payload.levels, loading: false };

    case types.GET_BNIX_FEE_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default bnixFee;
